import { render, staticRenderFns } from "./practicalTraining.vue?vue&type=template&id=0882b210&scoped=true"
import script from "./practicalTraining.vue?vue&type=script&lang=js"
export * from "./practicalTraining.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=0882b210&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882b210",
  null
  
)

export default component.exports